require('string-format');

//import GameScene from './game_scene';
import Game from './game';

import {LoadScene} from 'loadscene';
import LoadHandler from 'load_handler';//
import Space from 'frp/space'
import PIXI_video_performance_fix from "PIXI_video_performance_fix"
import own_version_info from "./version"

import {UrlParamsToObject} from "utils"

//Sounds не используется но нужно для того чтобы инициализировалась глобальная переменная:
import Sounds from 'sounds'

import {NoSleep} from 'vendor/my_no_sleep'


let game_container

let SETTINGS = {};

export const SCREEN_RATIO_1 = 16 / 9
//export const SCREEN_RATIO_2 = 4 / 3

let $ticker_seconds


// prevent context menu on production
// it is the only place the jQuery included on
if (NODE_ENV == "production") {
    $(document).on("contextmenu", function (event) { event.preventDefault(); });
}

/** Растянуть игру на весь экран с сохранением пропорций и отцентровать.*/
function fit( width, height, ratio, screen_config ) {

    //change the ratio of the canvas based on current window size to resize it:
    var w, h;

    if ( width / height >= ratio ) {
        w = height * ratio
        h = height
    }
    else {
        w = width
        h = width / ratio
    }

    PIXI.renderer.view.style.width = w + 'px';
    PIXI.renderer.view.style.height = h + 'px';

    //center canvas with weird "negative margins" approach (which proved to work on any browser starting from IE8):

    //trying to make it work on IE:
    PIXI.renderer.view.style.position = 'fixed';
    PIXI.renderer.view.style.display = "block";
    //PIXI.renderer.view.style.display = "inline-block";
    PIXI.renderer.view.style.left = "50%";
    PIXI.renderer.view.style.top = "50%";

    PIXI.renderer.view.style[ "margin-left" ] = "-" + w / 2 + "px";
    PIXI.renderer.view.style[ "margin-top" ] = "-" + h / 2 + "px";


    return { x : w, y : h }
}

/** Растянуть игру на весь экран БЕЗ сохранений пропорций, занимая всё доступное пространство.*/
function stretch( width, height ) {
    //пока что рефакторится использование PIXI в HTML, обойдёмся без stretch() - всё-равно никто не помнит как он должен работать и для чего делался (да и акцент сейчас на мобилки где stretch()'а быть не должно):
    return { x : width, y : height }
}

function getOrientation() {
    return window.orientation === 0 || window.orientation === 180 ? 'portrait' : 'landscape';
}

function initScreen( screenConfig, space ) {

    PIXI.renderer = PIXI.autoDetectRenderer(
        SETTINGS.canvas.width,
        SETTINGS.canvas.height,
        {
            antialias : false,
            transparent : false,
            resolution: window.devicePixelRatio || 1,
            autoResize:true,
            //может уменьшить разрывы между текстурами при скейлинге основного контейнера с игрой
            roundPixels: SETTINGS.roundPixels || false,
            //trying to fix flickering on android devices:
            preserveDrawingBuffer : true,
            backgroundColor : 0x011B22,
        }
    );
    PIXI.renderer.plugins.interaction.autoPreventDefault = true// false

    game_container = new PIXI.Container

    no_sleep( game_container )

    // space.s( 'screen_ratio' ).next( SCREEN_RATIO_1 )
    // console.log( 'canvas:', SETTINGS.canvas, 'resolution:', screenConfig.resolution )


    document.body.insertBefore(PIXI.renderer.view, document.body.firstChild);

    window.addEventListener( 'resize', () => {
        fit(window.innerWidth, window.innerHeight, 16/9, screenConfig);
    } );

    fit(window.innerWidth, window.innerHeight, 16/9, screenConfig);

}

function animate() {
    requestAnimationFrame( animate )
    try
    {
        PIXI.renderer.render( game_container )
    }
    catch ( e )
    {
        console.error( 'PIXI render fail:', e )
    }
}


export function main(resources, screenConfig, versionInfo)
{

    //clearTimeout( get_back_timeout )
    
    // ga_event( 'main' );
    // ga_timing( 'main' )

    const space = new Space( "game" );
    $ticker_seconds = ticker( space )

    //InitFullScreenSettings( space )
    
    PIXI_video_performance_fix()
    
    SETTINGS.screen = screenConfig;
    SETTINGS.canvas = SETTINGS.canvas || { width : 1920, height : 1080 };//{ width : 1366, height : 768 };


    cancelCaching( versionInfo );


    if ( versionInfo ) console.log( versionInfo.name + " build: " + versionInfo.build + " buildDate: " + versionInfo.buildDate )
    else console.log( 'versionInfo is undefined' )

    let LOADSCREEN_RESOURCES = [];
    // space.s( 'load:load' ).next( {
    //     name : 'loadscreen',
    //     graphics : LOADSCREEN_RESOURCES
    // } )


    LOADSCREEN_RESOURCES.push(screenConfig.loadscreen.image || 'res/loadscreen.jpg');
    LOADSCREEN_RESOURCES.push(screenConfig.loadscreen.loadbar.image || 'res/loadbar.png');

    // первоначальная загрузка элементов загрузочного экрана и служебных картинок
    PIXI.loader.add(LOADSCREEN_RESOURCES).load(() => {boot(resources, screenConfig, space)});
}

function boot(
    resources,
    screenConfig,
    space,

)
{
    initScreen( screenConfig/*, space */)

    let loadScene = new LoadScene(screenConfig);
    game_container.addChild(loadScene);

    const url_params = UrlParamsToObject();

    let serverLoadId = 1;
    let soundsLoadId = 2;
    let pixiLoadId = 3;
    const loadHandler = new LoadHandler(
        [
            {
                fraction : 0,
                id : serverLoadId
            },
            {
                fraction : ( resources.howler.length / ( resources.howler.length + resources.pixi.length ) ),
                id : soundsLoadId
            },
            {
                fraction : ( resources.pixi.length / ( resources.howler.length + resources.pixi.length ) ),
                id : pixiLoadId
            }
        ],
        () => {


            //popupScene.hideProcessIndicator();
            loadScene.hideConnectionIndicator();
            // sceneManager.removeScene('LoadScene');
            game_container.removeChild(loadScene);
            loadScene.destroy(true);
            loadScene = null;

        },
        portion => {
            loadScene.updateProgress( portion );
        }
    );

    console.log( "Is audio NOT supported: " + Howler.noAudio );

    let fatal = false;

    sounds.load(
        resources.howler,//.concat(COMMON_HOWLER_RESOURCES),
        () => {},//soundsLoadId,
        () => {},//loadHandler,
        trans_url
    );

    //load resources with PIXI:
    PIXI.loader.reset();

    let game = null;//let gameScene = null;

    //const commonPixiResources = getUserInterfaceResources(screenConfig, isMobile).concat(COMMON_PIXI_RESOURCES);

    PIXI.loader.add( resources.pixi/*.concat(commonPixiResources)*/ )
        .on('progress', function (loader, resource) {
            //console.log("loading: " + resource.url);
            // console.log("progress: " + loader.progress + "%");
            //If you gave your files names as the first argument
            //of the `add` method, you can access them like this
            // console.log("loading: " + resource.name);

            loadHandler.progress(
                pixiLoadId,
                loader.progress / 100.0
            );
        })
        .on(
            'error',
            msg => onFatal(
                msg,
                false,
                ( ! url_params[ 'nolobby' ] ) ? decodeURIComponent( cookies.get( 'lobby_url' ) ) : undefined
            ) )
        .load( () => {
            // if ( ! ga_graphics_reported )
            // {
            //     ga_graphics_reported = true
            //     ga_event( 'graphics_loaded' );
            // }

            loadHandler.loaded( pixiLoadId )

            game_container.removeChild(loadScene);
            loadScene.destroy(true);
            loadScene = null;

            // gameScene = new GameScene();
            // game_container.addChild(gameScene);
            game = new Game(game_container, url_params, space);

            console.log('LOAD!!!!!!')
        } )

    animate();
}

function cancelCaching()
{
    if ( ! own_version_info || ! own_version_info.build )
    {
        console.error( "NO BUILD INFORMATION" )
    }
    
    //cannot yet implement it for PIXI V3:
    if ( PIXI.version == 3 ) return
    
    var originalAdd = PIXI.loader.add;
    PIXI.loader.add = function()
    {
        //throughout the project resources are referenced the same way they're loaded so when we alter the URL to cancel caching they can't be referenced anymore (only sole ones - those without json wrappers), but PIXI allows specifying name separately from path so we define our own args:
        const newArgs = Array.prototype.slice.call( arguments );
        switch ( arguments.length )
        {
            case 1:
                const arg = arguments[ 0 ]
                if ( typeof arg === 'string' )
                {
                    newArgs[ 1 ] = trans_url( arg )
                }
                //no need to handle array since I know (it's not defined by API :( ) that PIXI just calls this function again with all the array values one-by-one ...
                else if ( Array.isArray( arg ) ) {}
                //our custom animation batch:
                else
                {
                    const arr = []
                    for ( let i = 0; i < arg.count; ++ i )
                    {
                        arr.push( arg.path.$( i ) )
                    }
                    newArgs[ 0 ] = arr
                    console.log( 'custom to', arg )
                }
                break;

            //that's how PIXI loads resources parsed out from .json files:
            case 4:
                newArgs[ 1 ] = trans_url( arguments[ 1 ] );
                break;

            default:
                console.warn( 'PIXI: Unknown resources load spec.', arguments );
                break;
        }

        return originalAdd.apply( PIXI.loader, newArgs );
    };
}


/** Cancel URL caching, redirect common resources and determin resources type.*/
function trans_url( URL )
{
    
    if ( URL.indexOf( '?' ) >= 0 ) return URL
    
    const normal_cache = own_version_info ? encodeURI( own_version_info.build ) : ( new Date() ).getTime()
    
    
    //ресурсы из pixi json файлов уже имеют нужный путь:
    if ( URL.startsWith( common_path() ) )
    {
        return URL + '?' + common_cache
    }
    
    // const t = 'res/common/'
    // if ( URL.indexOf( t ) == 0 )
    // {
    //     return common_path() + URL.substring( t.length ) + '?' + common_cache
    // }
    
    return URL + '?' + normal_cache
}

function ticker( space ) {
    const $tickerSeconds = space.s( "ticker" )
    let lastTime = Date.now()
    TweenMax.ticker.addEventListener('tick', function(event)  {
        TWEEN.update(performance.now());
        
        const now = Date.now();
        const dt = now - lastTime;
        
        lastTime = now;
        $tickerSeconds.next( dt / 1000 );
    })
    return $tickerSeconds
}

function no_sleep( stage )
{
    const ns = new NoSleep
    stage.interactive = true
    const enable = () => {
        console.log( 'Enabling NoSleep with PIXI event ...' )
        ns.enable()
        stage.off( 'pointerdown', enable )
    }
    stage.on( 'pointerdown', enable )
}

function tab_visibility( space )
{
    const $tab_visibility = space.s( 'tab_visibility' )
    $tab_visibility.next( true )
    document.addEventListener(
        'visibilitychange',
        () => $tab_visibility.next( document.visibilityState != 'hidden' )
    )
}






// WEBPACK FOOTER //
// ./src/boot.es6